import { ParseKeys } from 'i18next';
import { ChannelIcon, ChartLineIcon, FaceIcon, GearIcon, PaperIcon, PenIcon, ScreenArrowupIcon, SquareGridPlusIcon } from '@zep/icons';
import { SubscribePlan } from '../../../types';
interface Feature {
  key: ParseKeys<['subscription']>;
  icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
}
export const FREE_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.free.feature3',
  icon: props => <PenIcon {...props} />
}];
export const BASIC_NEW_FEATURES: Feature[] = [
  // 요청에 의해 스페이스 내 광고 팝업 제거 기능 삭제
  // {
  //   key: 'subscription:pricing.basic.feature2',
  //   icon: props => <XSmallCircleIcon {...props} />,
  // },
];
export const PRO_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.pro.feature4',
  icon: props => <PaperIcon {...props} />
}, {
  key: 'subscription:pricing.pro.feature2',
  icon: props => <GearIcon {...props} />
}, {
  key: 'subscription:pricing.pro.feature5',
  icon: props => <SquareGridPlusIcon {...props} />
}, {
  key: 'subscription:pricing.enterprise.feature2',
  icon: props => <ChartLineIcon {...props} />
} // 데대보
];
export const ENTERPRISE_NEW_FEATURES: Feature[] = [{
  key: 'subscription:pricing.enterprise.feature3',
  icon: props => <ScreenArrowupIcon {...props} />
}, {
  key: 'subscription:pricing.enterprise.feature4',
  icon: props => <FaceIcon {...props} />
}, {
  key: 'subscription:pricing.enterprise.feature5',
  icon: props => <ChannelIcon {...props} />
}];
export const BASIC_NEW_FEATURES_JA: Feature[] = [
  // 요청에 의해 스페이스 내 광고 팝업 제거 기능 삭제
  // {
  //   key: 'subscription:pricing.basic.feature2',
  //   icon: props => <XSmallCircleIcon {...props} />,
  // },
];
export const PRO_NEW_FEATURES_JA: Feature[] = [{
  key: 'subscription:pricing.pro.feature4',
  icon: props => <PaperIcon {...props} />
}, {
  key: 'subscription:pricing.pro.feature2',
  icon: props => <GearIcon {...props} />
}, {
  key: 'subscription:pricing.pro.feature5',
  icon: props => <SquareGridPlusIcon {...props} />
}];
export const ENTERPRISE_NEW_FEATURES_JA: Feature[] = [{
  key: 'subscription:pricing.enterprise.feature2',
  icon: props => <ChartLineIcon {...props} />
},
// 데대보
{
  key: 'subscription:pricing.enterprise.feature3',
  icon: props => <ScreenArrowupIcon {...props} />
}, {
  key: 'subscription:pricing.enterprise.feature4',
  icon: props => <FaceIcon {...props} />
}, {
  key: 'subscription:pricing.enterprise.feature5',
  icon: props => <ChannelIcon {...props} />
}];
export const SUBSCRIPTION_FEATURES: { [plan in SubscribePlan]: Feature[] } = {
  free: FREE_NEW_FEATURES,
  basic: FREE_NEW_FEATURES.concat(BASIC_NEW_FEATURES),
  pro: BASIC_NEW_FEATURES.concat(PRO_NEW_FEATURES),
  enterprise: BASIC_NEW_FEATURES.concat(PRO_NEW_FEATURES, ENTERPRISE_NEW_FEATURES)
};
export const SUBSCRIPTION_FEATURES_JA: { [plan in SubscribePlan]: Feature[] } = {
  free: FREE_NEW_FEATURES,
  basic: FREE_NEW_FEATURES.concat(BASIC_NEW_FEATURES_JA),
  pro: BASIC_NEW_FEATURES_JA.concat(PRO_NEW_FEATURES_JA),
  enterprise: BASIC_NEW_FEATURES_JA.concat(PRO_NEW_FEATURES_JA, ENTERPRISE_NEW_FEATURES_JA)
};
export const INFINITE_MAX_CCU = -1;